import { render } from "./UndergroundTokens.vue?vue&type=template&id=0a7734f6&ts=true"
import script from "./UndergroundTokens.vue?vue&type=script&lang=ts"
export * from "./UndergroundTokens.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__